////////////////////////////////////////////////////////////////
// enums
////////////////////////////////////////////////////////////////

export enum CrmRoute {

    // home
    ACCOUNT_HOME                  = 'CrmRoute.ACCOUNT_HOME',
    
    // auth
    AUTH_LOGIN                    = 'CrmRoute.AUTH_LOGIN',
    AUTH_ACCESS_CODE_LOGIN        = 'CrmRoute.AUTH_ACCESS_CODE_LOGIN',

    AUTH_PASSWORD_RESET           = 'CrmRoute.AUTH_PASSWORD_RESET',
    AUTH_PASSWORD_RESET_CONFIRMED = 'CrmRoute.AUTH_PASSWORD_RESET_CONFIRMED',

    // views
    VIEW_FILES                    = 'CrmRoute.VIEW_FILES',
    VIEW_SINGLE_FILE              = 'CrmRoute.VIEW_SINGLE_FILE',
    VIEW_CASES                    = 'CrmRoute.VIEW_CASES',

    // settings
    VIEW_SETTINGS                 = 'CrmRoute.VIEW_SETTINGS',
    VIEW_SETTINGS_FTP             = 'CrmRoute.VIEW_SETTINGS_FTP',
    VIEW_SETTINGS_PAYMENT         = 'CrmRoute.VIEW_SETTINGS_PAYMENT',
    
    // other
    NOT_FOUND                     = 'CrmRoute.NOT_FOUND',
    TECHNICAL_DIFFICULTIES        = 'CrmRoute.TECHNICAL_DIFFICULTIES',

}

export enum CrmRouteAccessMode {
    UNAUTHORIZED_ONLY = 'CrmRouteAccessMode.UNAUTHORIZED_ONLY',
    ALWAYS_ACCESSIBLE = 'CrmRouteAccessMode.ALWAYS_ACCESSIBLE',
}
